<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="650"
    [nzVisible]="isVisibleAnnouncementDrawer" [nzTitle]="announcementDrawerTitle" [nzFooter]="footerTpl"
    (nzOnClose)="handleCancel()">
    <form nz-form *nzDrawerContent [formGroup]="_fS.announcementForm">
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="titleError">
                        <label class="label-text required">Title</label>
                        <input type="text"
                            class="input-group" nz-input placeholder="Enter title" formControlName="title" maxlength="50" minlength="2">
                    </nz-form-control>
                    <ng-template #titleError let-control>
                        <ng-container *ngIf="control.hasError('required')">Please enter title</ng-container>
                        <ng-container *ngIf="control.hasError('minlength')">Title {{validationMessage.minlength}}</ng-container>
                        <ng-container *ngIf="control.hasError('pattern')">Please enter title</ng-container>
                    </ng-template>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <div appFileDragNDrop (filesChangeEmiter)="onFileChange($event)" class="dropzone">
                    <nz-form-control nzErrorTip="Please enter description">
                        <div class="d-flex"><label class="label-text required">Description</label><span nz-icon nzType="fullscreen" nzTheme="outline" (click)="openInFullScreen()" class="ml-1 mt-5" nz-tooltip nzTooltipTitle="Full Screen"></span></div>
                        <!-- <textarea nz-input rows="3" formControlName="desc" placeholder="Enter Description"
                            maxlength="1000"></textarea> -->
                            <angular-editor formControlName="desc" [config]="editorConfig" (blur)="checkImageUploaded()"></angular-editor>
                            <span *ngIf="currentUploadedImageSize">Last uploaded image size: {{currentUploadedImageSize}}</span>
                    </nz-form-control>
                </div>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-control nzErrorTip="Please select start date and time">
                        <label class="label-text required">Start</label>
                        <nz-date-picker [nzDisabledDate]="disabledStartDate" nzShowTime nzFormat="MM/dd/yyyy hh:mm:ss a"
                            formControlName="start" nzPlaceHolder="Start"
                            (nzOnOpenChange)="handleStartOpenChange($event)"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-control nzErrorTip="Please select end date and time">
                        <label class="label-text required">End</label>
                        <nz-date-picker #endDatePicker [nzDisabledDate]="disabledEndDate" nzShowTime nzFormat="MM/dd/yyyy hh:mm:ss a"
                            formControlName="end" nzPlaceHolder="End"
                            (nzOnOpenChange)="handleEndOpenChange($event)"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="unitError">
                    <label class="label-text required">Account and Sites</label>
                    <gs-select #AccountAndSitesGsSelect [selectDataParentChild]="sitesData" [showAllCheckbox]="true" [selectPlaceholder]="'Select Account and Sites'"
                    [hideOptionsAfter]="1" [responsiveOptionHiding]="false" [moduleToCheckParent]="'announcement'"
                        [allowMultiSelect]="true" [isParentChild]="true" [showSearch]="true"
                        (DropDownChanged)="sitesDropdownChanged($event)"
                        [ngClass]="showSitesInvalidMessage ? 'redBorder': ''"></gs-select>
                    <p *ngIf="showSitesInvalidMessage" class="vis-red">Please select at least one account and sites</p>
                    <ng-template #unitError let-control>
                        <ng-container *ngIf="control.hasError('required')">Please select account and sites</ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item class="margin-none">
                    <nz-form-control class="switch-box">
                        <nz-switch formControlName="isActive"></nz-switch>
                        <label class="switch-label black mr-1">{{
                            _fS.announcementForm.get("isActive").value ? "Active" : "Inactive"
                            }}</label>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end ">
            <button nz-button nzType="primary" (click)="showPreviewModal()" [nzLoading]="isSubmitting"
                class="medium-btn small-btn width-100 mr-1">{{selectedAnnoucementData != null ? 'Update' :
                'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()"
                class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>
<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="'100%'" nzCentered
  [nzVisible]="isVisibleFullScreenModal" [nzTitle]="'Announcement Description'"
  nzClassName="investment-modal new-investment-modal" [nzFooter]="fullscreenfooter" (nzOnCancel)="handleCancelFullScreen()">
<div *nzModalContent>
    <angular-editor [(ngModel)]="descFullScreen" [config]="editorConfig" ></angular-editor>
</div>
<ng-template #fullscreenfooter>
    <div class="d-flex justify-content-end">
        <button nz-button nzType="primary" (click)="handleCancelFullScreen()"
            class="medium-btn small-btn mr-1">Done</button>
    </div>
</ng-template></nz-modal>



<div style="display: none;">
    <button id="UpdateUploadedImageSizeButton" (click)="UpdateUploadedImageSize()"></button>
</div>

<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
  [nzVisible]="isVisibleModal" nzTitle="Announcement Preview" [nzFooter]="previewFooterTpl" (nzOnCancel)="isVisibleModal = false">
  <ng-container *nzModalContent>
    <div class="confirm-modal-sub-title" [innerHTML]="currentDescription"></div>
  </ng-container>
  <ng-template #previewFooterTpl>
    <div class="d-flex justify-content-end">     
      <button nz-button nzType="primary" (click)="handleOk(); isVisibleModal= false"
        class="medium-btn small-btn">
     Done
      </button>
    </div>
  </ng-template>
</nz-modal>